module.exports = __webpack_public_path__ + "static/media/main-explosion.3c666e7.mp3";


//////////////////
// WEBPACK FOOTER
// ./static/audio/main-explosion.mp3
// module id = a5i6
// module chunks = 1